import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import vuetify from '@/plugins/vuetify';
import './plugins/vue-axios';
import * as VueGoogleMaps from 'vue2-google-maps';

import { domain, clientId } from '../auth_config.json';

import { Auth0Plugin } from './auth';
import io from 'socket.io-client';
import VueSocketIOExt from 'vue-socket.io-extended';

// const socket = io(process.env.VUE_APP_SOCKETIO_URL);

// Vue.use(VueSocketIOExt, socket);

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: appState => {
    router
      .push(
        appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
      )
      .catch(err => console.log(err));
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAR7Sm99F0yOd-7LSrOJten2-ydQ2vo5As',
    libraries: 'places'
  }
});

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
